import React, { Suspense } from 'react';

// Lazy so react-pdf/pdfjs stay out of the main bundle; feedUtility is imported eagerly via shared hooks.
const PdfViewer = React.lazy(() => import('../../../shared/components/pdf-viewer/pdf-viewer'));

/**
 * PDF body for AttachmentChip / AttachmentViewerModal in the admin portal (react-pdf via shared PdfViewer).
 */
export const ADMIN_ATTACHMENT_RENDER_CONTENT_BY_FILE_TYPE = {
  pdf: ({ fileUrl, fileName }) =>
    React.createElement(Suspense, { fallback: null }, React.createElement(PdfViewer, { fileUrl, fileName })),
};
